import type { ReactNode, RefObject } from 'react'
import type { PropsWithAriaLabel, PropsWithAriaLabelledBy } from '../../../types'
import type { NamedIconComponentType } from '../../icon'

export enum InputSize {
  xsmall = 'xs',
  small = 's',
  medium = 'm',
  large = 'l',
  xlarge = 'xl',
}

export enum InputVariant {
  neutral = 'neutral',
  critical = 'critical',
}

export enum InputType {
  text = 'text',
  password = 'password',
  tel = 'tel',
  number = 'number',
  email = 'email',
}

interface HTMLInputAttributes
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size' | 'prefix'> {}

interface InternalBaseInputProps extends HTMLInputAttributes {
  className?: string
  disabled?: boolean
  readonly?: boolean
  leadingAccessory?: ReactNode
  trailingAccessory?: ReactNode
  leadingIcon?: NamedIconComponentType
  placeholder?: string
  prefix?: string | ReactNode
  rtl?: boolean
  size?: InputSizeType
  suffix?: string
  trailingIcon?: NamedIconComponentType
  type?: InputTypeType
  value?: string
  variant?: InputVariant
  ref?: RefObject<HTMLInputElement>
  clearable?: boolean
}

export type BaseInputProps =
  | (PropsWithAriaLabel & InternalBaseInputProps)
  | (PropsWithAriaLabelledBy & InternalBaseInputProps)

export type InputVariantType = `${InputVariant}`
export type InputTypeType = `${InputType}`
export type InputSizeType = `${InputSize}`
